import { useEffect, useState } from 'react';

// Отдельным файлом от компонентов: файл, экспортирующий и компонент, и хук, ломает
// fast refresh — правка хука перезагружает дерево целиком. То же правило, по которому
// в `printing/shared/moment.ts` живут утилиты, а не диалог.

/**
 * Узкий экран. Тот же рубеж, что у бургера в `appNav.module.css` (767px):
 * действие обязано переезжать ровно тогда, когда появляется бургер, иначе
 * между 768 и 767 в полосе окажется и то и другое.
 */
const QUERY = '(max-width: 767px)';

/**
 * `matchMedia` может отсутствовать: его нет в jsdom, и его может не оказаться
 * в старой WebView-оболочке. Отсутствие трактуется как ШИРОКИЙ экран — то есть
 * действие остаётся в шапке страницы, на своём обычном месте. Обратный выбор
 * означал бы, что там, где среду распознать не удалось, кнопка уезжает в слот,
 * которого может не быть, и исчезает совсем.
 */
function matches(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(QUERY).matches
    : false;
}

export function useIsNarrow(): boolean {
  const [narrow, setNarrow] = useState(matches);

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') {
      return;
    }
    const query = window.matchMedia(QUERY);
    const update = (): void => {
      setNarrow(query.matches);
    };
    update();
    query.addEventListener('change', update);
    return () => {
      query.removeEventListener('change', update);
    };
  }, []);

  return narrow;
}
